// extracted by mini-css-extract-plugin
module.exports = {"outer":"EntryForm_outer__wfkka","inner":"EntryForm_inner__JA1cs"};